var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#96A1AC",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8956 20.4736H22.5271C21.9688 20.4736 21.4333 20.6954 21.0385 21.0903C20.6437 21.4851 20.4219 22.0206 20.4219 22.5789V29.9474C20.4219 30.5057 20.6437 31.0412 21.0385 31.436C21.4333 31.8309 21.9688 32.0527 22.5271 32.0527H29.8956C30.4539 32.0527 30.9894 31.8309 31.3842 31.436C31.779 31.0412 32.0008 30.5057 32.0008 29.9474V22.5789C32.0008 22.0206 31.779 21.4851 31.3842 21.0903C30.9894 20.6954 30.4539 20.4736 29.8956 20.4736Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9474 18.3685V15.2106C30.9474 14.6522 30.7256 14.1167 30.3308 13.7219C29.9359 13.3271 29.4005 13.1053 28.8421 13.1053H26.7369C26.7369 12.5469 26.515 12.0114 26.1202 11.6166C25.7254 11.2218 25.1899 11 24.6316 11H18.3158C17.7574 11 17.222 11.2218 16.8271 11.6166C16.4323 12.0114 16.2105 12.5469 16.2105 13.1053H14.1053C13.5469 13.1053 13.0114 13.3271 12.6166 13.7219C12.2218 14.1167 12 14.6522 12 15.2106V27.8422C12 28.4006 12.2218 28.9361 12.6166 29.3309C13.0114 29.7257 13.5469 29.9475 14.1053 29.9475H18.3158V20.4737C18.3158 19.9154 18.5376 19.3799 18.9324 18.9851C19.3272 18.5903 19.8627 18.3685 20.4211 18.3685H30.9474ZM18.3158 15.2106V13.1053H24.6316V15.2106H18.3158Z",
    fill: "#333D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.7d5ed2f56594fa58b2550ba24ad6b612.svg";
export { ForwardRef as ReactComponent };